import {Component, Input, OnChanges, OnInit, SimpleChanges,} from '@angular/core';
import {ToolsService} from '../../../../services/tools.service';

@Component({
  selector: 'app-price-info',
  templateUrl: './price-info.component.html',
  styleUrls: ['./price-info.component.scss'],
})
export class PriceInfoComponent implements OnInit, OnChanges {
  @Input() activityLength: string;
  @Input() price: string;
  @Input() isFromPrice: boolean;
  @Input() priceDescription: string;
  @Input() parentCssClass: string;

  public formattedPrice: string;
  public isPriceEmpty: boolean;
  public showDelimiter: boolean;

  constructor(
    private tools: ToolsService,
  ) {
  }

  ngOnInit(): void {
    this.onDataUpdated();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.onDataUpdated();
  }

  private updateIsPriceEmpty(): void {
    this.isPriceEmpty = this.price == null || this.price === '';
  }

  private updateShowDelimiter(): void {
    this.showDelimiter =
      this.activityLength != null &&
      this.activityLength !== '' &&
      (!this.isPriceEmpty ||
        (this.priceDescription != null && this.priceDescription !== ''));
  }

  private onDataUpdated(): void {
    this.formatPrice();
    this.updateIsPriceEmpty();
    this.updateShowDelimiter();
  }

  private formatPrice(): void {
    if (!this.tools.isNil(this.price) && this.price !== '') {
      this.formattedPrice = `${parseFloat(
        this.price.replace(' ', '')
      ).toString()} kr`;
    } else {
      this.formattedPrice = '';
    }
  }
}
